import React from 'react';
import { useIntl } from '@atlassian/jira-intl';
import { Button } from '@atlassian/jira-portfolio-3-common';
import messages from './messages';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import type { Props } from './types';

function ResetButton({ showReset, reset, onFilterChange }: Props) {
	const intl = useIntl();

	// We hide the button using CSS so the event bubble up correctly when reset is triggered and the select dropdowns are closed automatically
	return (
		<div style={{ display: showReset ? 'flex' : 'none' }}>
			{/* eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766 */}
			<div className={styles.divider} />
			<Button
				appearance="subtle-link"
				testId="portfolio-3-portfolio.app-simple-plans.main.tabs.dependencies.filters.reset-button"
				onClick={() => {
					reset();
					onFilterChange();
				}}
				ariaLabel={intl.formatMessage(messages.resetFilterLabel)}
			>
				{intl.formatMessage(messages.label)}
			</Button>
		</div>
	);
}

export default ResetButton;
